module.exports = __webpack_public_path__ + "img/icon4.e19073ae.png";